import { data } from "react-router-dom";
import api from "../api";

export const addCourse = async (formData) => {
    try {
      const response = await api.post('/course/add', formData, {
        headers: {
          'Content-Type': 'multipart/form-data', 
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };

 export const addPolicy = async (data) => {
  try {
    const response = await api.post('/policy/create', data, {
      headers: {
        'Content-Type': 'multipart/form-data', // ✅ explicitly tell server
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error adding policy:', error);
    throw error;
  }
};

    export const addSales = async (data) => {
    try {
      const response = await api.post('/sales/add', data);
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };
    export const addReaction = async (data) => {
    try {
      const response = await api.post('/feed/addReaction', data);
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };
   export const addFeed = async (data) => {
   try {
      const response = await api.post('/feed/add', data, {
        headers: {
          'Content-Type': 'multipart/form-data', 
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };

  export const updateCourse = async (formData,id) => {
    try {
      const response = await api.put(`/course/update/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data', 
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };

    export const updatePolicy = async (formData,id) => {
    try {
      const response = await api.put(`/feed/update/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data', 
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };

    export const updateFeed = async (formData,id) => {
    try {
      const response = await api.put(`/feed//update/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data', 
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };

  // export const updatePolicy = async (data,id) => {
  //   try {
  //     const response = await api.patch(`/policy/update/${id}`, data);
  //     return response.data;
  //   } catch (error) {
  //     console.error('Error adding course:', error);
  //     throw error;
  //   }
  // };

  
  export const updateSales = async (data,id) => {
    try {
      const response = await api.put(`/sales/update/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };

  // export const getAllCourses = async () => {
  //   try {
  //     const response = await api.get('/course/all');
  //     return response.data;
  //   } catch (error) {
  //     console.error('Error fetching courses:', error);
  //     throw error;
  //   }
  // };

  export const getAllCourses = async ({ page = 1, search = '' }) => {
  try {
    const response = await api.get('/course/all', {
      params: {
        page,
        search
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching courses:', error);
    throw error;
  }
};

  export const getMyPolicies = async ({ page = 1, search = '' }) => {
  try {
    const response = await api.get('/policy/my', {
      params: {
        page,
        search
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching courses:', error);
    throw error;
  }
};
 export const getMyFeeds = async ({ page = 1, search = '' }) => {
  try {
    const response = await api.get('/feed/myFeed', {
      params: {
        page,
        search
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching courses:', error);
    throw error;
  }
};
  export const getAllStaff = async (courseId = "") => {
    try {
      const response = await api.get(`/staff/all?courseId=${courseId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching courses:', error);
      throw error;
    }
  };

  export const deleteCourse = async (courseId) => {
    try {
      const response = await api.delete(`/course/delete/${courseId}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting course with ID ${courseId}:`, error);
      throw error;
    }
  };

  export const deleteMyPolicy = async (courseId) => {
    try {
      const response = await api.delete(`/policy/delete/${courseId}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting course with ID ${courseId}:`, error);
      throw error;
    }
  };
  export const deleteMyFeed = async (courseId) => {
    try {
      const response = await api.delete(`/feed/delete/${courseId}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting course with ID ${courseId}:`, error);
      throw error;
    }
  };
    export const deleteMySalesData = async (courseId) => {
    try {
      const response = await api.delete(`/sales/delete/${courseId}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting course with ID ${courseId}:`, error);
      throw error;
    }
  };

  export const assignStaff = async (data) => {
    try {
      const response = await api.post('/course/assignToStaff', data);
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };

   

   export const getCoursesById = async (id) => {
    try {
      const response = await api.get(`/course/details/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching courses:', error);
      throw error;
    }
  };

    export const getMyPolicyById = async (id) => {
    try {
      const response = await api.get(`/policy/get/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching courses:', error);
      throw error;
    }
  };
   export const getMyFeedById = async (id) => {
    try {
      const response = await api.get(`/feed/get/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching courses:', error);
      throw error;
    }
  };
  export const getMySalesById = async (id) => {
    try {
      const response = await api.get(`/sales/get/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching courses:', error);
      throw error;
    }
  };
   export const getPolicyById = async (id) => {
    try {
      // const response = await api.get(`/policy/get/${id}`);
      const response = await api.get(`/feed/get/${id}`);

      return response.data;
    } catch (error) {
      console.error('Error fetching courses:', error);
      throw error;
    }
  };

     export const getAllFeeds = async () => {
    try {
      const response = await api.get(`/feed/show`);
      return response.data;
    } catch (error) {
      console.error('Error fetching courses:', error);
      throw error;
    }
  };

  export const getMyProfileData = async () => {
    try {
      const response = await api.get(`/auth/profile`);
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };

  //   export const getAllSalesByTrainer = async () => {
  //   try {
  //     const response = await api.get(`/sales/trainer`);
  //     return response.data;
  //   } catch (error) {
  //     console.error('Error adding course:', error);
  //     throw error;
  //   }
  // };

  export const getAllSalesByTrainer = async ({ page = 1, search = '' }) => {
  try {
    const response = await api.get('/sales/trainer', {
      params: {
        page,
        search
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching courses:', error);
    throw error;
  }
};

 export const getMyDashboardData = async () => {
    try {
      const response = await api.get(`/trainer/dashboard`);
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };

  export const getLeaderboardData = async ({ page = 1, filter = '' }) => {
  try {
    const response = await api.get('/sales/leaderboard', {
      params: {
        page,
        filter
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching courses:', error);
    throw error;
  }
};

 export const getAllUserForChat = async (value) => {
    try {
      const response = await api.get(`/contacts/all?search=${value}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching courses:', error);
      throw error;
    }
  };

  //  export const createChat = async (data) => {
  //   try {
  //     const response = await api.post('/chat/createChat', data);
  //     return response.data;
  //   } catch (error) {
  //     console.error('Error adding course:', error);
  //     throw error;
  //   }
  // };

  export const createChat = async (formData) => {
    try {
      const response = await api.post('/chat/createChat', formData, {
        headers: {
          'Content-Type': 'multipart/form-data', 
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };

  export const sendMessageApi = async (formData) => {
    try {
      const response = await api.post('/chat/sendMessage', formData, {
        headers: {
          'Content-Type': 'multipart/form-data', 
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };

  //   export const sendMessageApi = async (data) => {
  //   try {
  //     const response = await api.post('/chat/sendMessage', data);
  //     return response.data;
  //   } catch (error) {
  //     console.error('Error adding course:', error);
  //     throw error;
  //   }
  // };

  
   export const getAllUser = async () => {
    try {
      const response = await api.get('/chat/myChats');
      return response.data;
    } catch (error) {
      console.error('Error fetching courses:', error);
      throw error;
    }
  };

     export const readAllChat = async (id) => {
    try {
      const response = await api.get(`chat/readChat/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching courses:', error);
      throw error;
    }
  };

  export const updateProfile = async (formData) => {
    try {
      const response = await api.post('/auth/profile', formData, {
        headers: {
          'Content-Type': 'multipart/form-data', 
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };

  export const getMyNotifications = async () => {
    try {
      const response = await api.get(`/notifications`);
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };
  export const getMyNotificationsWithPagination = async ({ page = 1 }) => {
    try {
      const response = await api.get(`/notifications`,{
      params: {
        page
      }
    });
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };

    export const downloadStaffByTrainer = async () => {
    try {
      const response = await api.get(`/staff/export`);
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };

  export const downloadCourseByTrainer = async () => {
    try {
      const response = await api.get(`/course/myExports`);
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };
   export const downloadPolicyByTrainer = async () => {
    try {
      const response = await api.get(`/policy/myExports`);
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };

   export const downloadSalesByTrainer = async () => {
    try {
      const response = await api.get(`/sales/myExports`);
      return response.data;
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };